import { useTranslation } from "react-i18next";

import { IconButton } from "#components/atoms/IconButton/IconButton";
import { InputNumber } from "#components/atoms/InputNumber/InputNumber";
import { Tooltip } from "#components/atoms/Tooltip/Tooltip";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useDeleteQuoteRequestLine } from "#modules/quoteRequestLines/view/useDeleteQuoteRequestLine";
import { useUpdateQuoteRequestLineQuantity } from "#modules/quoteRequestLines/view/useUpdateQuoteRequestLineQuantity";
import { Icon } from "#shared/icons/Icon";

import classes from "./BatchQuantityCell.module.css";

type Props = {
  line: QuoteRequestLineDto;
};

const BatchQuantityCell = ({ line }: Props) => {
  const { t } = useTranslation();
  const { updateQuoteRequestLineQuantity } = useUpdateQuoteRequestLineQuantity();
  const { deleteQuoteRequestLine, isPending } = useDeleteQuoteRequestLine();

  return (
    <div className={classes.wrapper}>
      <div className={classes.inputWrapper}>
        <InputNumber
          placeholder={t("quoteRequestV2.column.quantityPlaceholder")}
          value={line.quantity}
          onChange={(quantity) =>
            updateQuoteRequestLineQuantity({ id: line.id, payload: { quantity } })
          }
          size="sm"
        />
      </div>
      <Tooltip label={t("quoteRequestV2.batch.deleteBatch")}>
        <span className={classes.deleteButton}>
          <IconButton
            variant="transparent"
            size="sm"
            aria-label={t("quoteRequestV2.batch.deleteBatch")}
            disabled={isPending}
            onClick={() => deleteQuoteRequestLine(line.id)}
          >
            <Icon name="x" size={14} />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

export { BatchQuantityCell };
